import * as React from "react"

export const NovaLogo: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width={props.width || "280"}
    height={props.height || "303"}
    viewBox="0 0 280 303"
    fill="none"
    xlinkTitle="NOVA"
    xmlns="http://www.w3.org/2000/svg"
    className={"fill-fg-1"}
    {...props}>
    <title>NOVA</title>
    <path d="M0 0V302.488H64.4007V75.6219L139.535 151.244V64.8188L75.1342 0H0ZM214.669 226.866L139.535 151.244V237.669L203.936 302.488H279.07V0H214.669V226.866Z" />
  </svg>
)
